<template lang="pug">
  b-container(fluid)
    p Plataformas de ecommerce disponibles:
    ol
      li
        b-link(v-scroll-to="{el: '#shopify', container: '#router-container'}") Shopify
    #shopify
      h4 Shopify
      p.text-secondary Para conectar Shopify da click en el siguiente botón y autoriza permisos a Konverza para administrar tu tienda.
      b-form-group(label="Nombre de tu tienda", description="Proporciona el nombre de tu tienda que deseas conectar")
        b-input-group
          b-form-input(placeholder="Nombre de tu tienda", v-model="shop_name", :state="validShopName", type="search", autocomplete="off")
          b-input-group-append
            b-button(variant="light", id="whereDoIFindIt")
              span.mr-1.text-sm(v-if="$breakpoint.mdUp") ¿Dónde lo encuentro?
              info-icon.icon-sm
      b-button(variant="success", @click="authenticate('shopify')", :disabled="!validShopName") Conectar Shopify
      b-popover(target="whereDoIFindIt", triggers="focus", placement="bottom", custom-class="popover-shopify-image")
        p.mb-2 El nombre de tu tienda lo puedes encontrar en la barra de direcciones cuando entras a tu administrador de Shopify:
        b-img.mb-2(src="@/assets/shopify_name.png", fluid-grow)
        p.mb-1.text-secondary https://
          span.font-weight-bold.text-primary nerdstest
          span .myshopify.com
        p.mb-0.text-secondary En este ejemplo el nombre de la tienda es
          span.font-weight-bold.text-primary.ml-1 nerdstest
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex'
const facebookController = createNamespacedHelpers('facebook')

export default {
  data () {
    return {
      shop_name: ''
    }
  },
  computed: {
    validShopName () {
      return this.shop_name ? /^[a-zA-Z0-9\-]+$/.test(this.shop_name) : null

    }
  },
  methods: {
    ...mapActions(['auth/authenticate']),
    authenticate (platform) {
      let self = this

      this['auth/authenticate']({
        provider: platform,
        shop: self.shop_name,
        payload: {
          account_id: self.$route.params.account_id
        },
        callback: res => {
          if (res.success) {
            self.$message.success('Cuenta conectada con éxito')
          } else {
            this.$message.error(res.error)
          }
        }
      })
    },
  }
}
</script>

<style lang="scss">
  .popover-shopify-image {
    @media (min-width:376px) {
      min-width: 400px !important;
    }
  }
</style>
